import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VContainer,
    { attrs: { fluid: "", "grid-list-xl": "" } },
    [
      _c("app-monitoramento", {
        attrs: {
          acesso: _vm.acesso,
          fim: _vm.diagnostico.fimResponsabilidadeChefia,
          inicio: _vm.diagnostico.inicioResponsabilidadeChefia,
          monitoramento: "diagnostico",
          perspectiva: "COMPORTAMENTAL",
          titulo: "Diagnóstico Comportamental",
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  VCol,
                  { attrs: { centered: "", cols: "12", "no-gutters": "" } },
                  [
                    _c(
                      VRow,
                      { staticClass: "justify-center ma-2" },
                      [
                        _c(
                          VTabs,
                          {
                            attrs: { centered: "", "icons-and-text": "" },
                            model: {
                              value: _vm.categoria,
                              callback: function ($$v) {
                                _vm.categoria = $$v
                              },
                              expression: "categoria",
                            },
                          },
                          [
                            _c(VTabsSlider, {
                              attrs: { color: "secondary" },
                            }),
                            _vm._l(_vm.categorias.length, function (i) {
                              return _c(
                                VTab,
                                {
                                  key: i,
                                  staticClass: "mt-3",
                                  attrs: {
                                    href: "#" + _vm.categorias[i - 1].id,
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "grey--text text--darken-2",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.categorias[i - 1].descricao)
                                      ),
                                    ]
                                  ),
                                  _c(
                                    VIcon,
                                    {
                                      attrs: {
                                        color:
                                          _vm.categorias[i - 1].id ===
                                          _vm.categoria
                                            ? "secondary"
                                            : "grey",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.categorias[i - 1].icone) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            }),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                    _c(
                      VRow,
                      { staticClass: "justify-center ma-1" },
                      [
                        _c(
                          VCol,
                          { attrs: { cols: "12" } },
                          [
                            _c(
                              VRow,
                              [
                                _c(
                                  VToolbar,
                                  { attrs: { flat: "" } },
                                  [
                                    _c(VToolbarTitle, [
                                      _c(
                                        "h2",
                                        {
                                          staticClass:
                                            "title primary--text text--darken-1 text-no-wrap mt-0",
                                        },
                                        [_vm._v(" FILTROS ")]
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              VRow,
                              [
                                _c("select-multiple-unidades", {
                                  attrs: {
                                    "mapeamento-id":
                                      _vm.diagnostico.mapeamento.id,
                                  },
                                  model: {
                                    value: _vm.unidades,
                                    callback: function ($$v) {
                                      _vm.unidades = $$v
                                    },
                                    expression: "unidades",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm.relatorios.length > 0
                          ? _c(
                              VCol,
                              { attrs: { cols: "12" } },
                              [
                                _c(
                                  VRow,
                                  [
                                    _c(
                                      VToolbar,
                                      { attrs: { flat: "" } },
                                      [
                                        _c(VToolbarTitle, [
                                          _c(
                                            "h2",
                                            {
                                              staticClass:
                                                "title primary--text text--darken-1 text-no-wrap mt-0",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    `GRÁFICOS ${_vm.unidades.visualizacao}`
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  VRow,
                                  {
                                    ref: "graficos",
                                    staticClass: "justify-center",
                                    attrs: { id: "grafico-gauge" },
                                  },
                                  [
                                    _c(
                                      VCol,
                                      { attrs: { cols: "12" } },
                                      [
                                        _c("gauge-chart", {
                                          attrs: {
                                            dados: _vm.gaugeChart,
                                            fonte: `Fonte: Sistema Desenvolva, ${_vm.anoDiagnostico}`,
                                            maximo: 100,
                                            minimo: 0,
                                            titulo: `Participação do Diagnóstico Comportamental ${_vm.unidades.visualizacao}`,
                                            descricao:
                                              "Percentual de Conclusão da(s) Unidade(s)",
                                            "descricao-titulo":
                                              "Participação do Diagnóstico Comportamental",
                                            formato: "%",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  VRow,
                                  [
                                    _c(
                                      VCol,
                                      [
                                        _c("tabela-quadro-resumo", {
                                          attrs: {
                                            relatorios: _vm.relatorios,
                                            titulo: `QUADRO RESUMO DO DIAGNÓSTICO COMPORTAMENTAL ${_vm.unidades.visualizacao}`,
                                            perspectiva: "COMPORTAMENTAL",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  VRow,
                                  [
                                    _c(
                                      VCol,
                                      [
                                        _c("tabela-resultados", {
                                          attrs: {
                                            relatorios: _vm.relatorios,
                                            titulo: `RESULTADOS ${_vm.unidades.visualizacao}`,
                                            perspectiva: "COMPORTAMENTAL",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  VRow,
                                  [
                                    _c(
                                      VCol,
                                      [
                                        _c("tabela-dispensados", {
                                          attrs: {
                                            relatorios: _vm.relatorios,
                                            titulo: `SERVIDORES DISPENSADOS ${_vm.unidades.visualizacao}`,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  VRow,
                                  { staticClass: "justify-end mb-1" },
                                  [
                                    _c("botao-PDF", {
                                      attrs: {
                                        relatorios: _vm.relatorios,
                                        diagnostico: _vm.diagnostico,
                                        "unidades-visualizacao":
                                          _vm.unidades.visualizacao,
                                        perspectiva: "COMPORTAMENTAL",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }